var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"hHh LpR fff"}},[_c('AppHeader'),_c('AppDrawer'),_c('q-page-container',[_c('Child')],1),_c('FooterElement'),(_vm.showFooter)?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }